import LocalizedStrings from "react-localization";
import localizations from "../localization";
import {useLanguage} from "../contexts/LanguageProvider";

export default function useTranslation() {
  const {language} = useLanguage();
  let translation = new LocalizedStrings(localizations);

  translation.setLanguage(language);
  return translation;
}
